// components/Header.js - Header component with controls
import React from 'react';

function Header({
  moves,
  gameComplete,
  startNewGame,
  gameStarted,
  difficulty,
  changeDifficulty,
  toggleSettings,
}) {
  // Function to handle difficulty selection and start a new game
  const selectDifficultyAndStart = (level) => {
    changeDifficulty(level);
    // If game isn't started yet, start it
    if (!gameStarted) {
      startNewGame();
    }
  };

  return (
    <header className="game-header">
      <h1>Memory Birbs</h1>

      <div className="game-stats">
        <p>Moves: {moves}</p>
        {gameComplete && (
          <div className="game-complete">
            <h2>Congratulations!</h2>
            <p>You completed the game in {moves} moves!</p>
          </div>
        )}
      </div>

      <div className="game-controls">
        <div className="difficulty-selector">
          <div className="difficulty-buttons">
            <button
              className={difficulty === 'easy' ? 'active' : ''}
              onClick={() => selectDifficultyAndStart('easy')}
            >
              Easy
            </button>
            <button
              className={difficulty === 'medium' ? 'active' : ''}
              onClick={() => selectDifficultyAndStart('medium')}
            >
              Medium
            </button>
            <button
              className={difficulty === 'hard' ? 'active' : ''}
              onClick={() => selectDifficultyAndStart('hard')}
            >
              Hard
            </button>
          </div>
        </div>

        <button
          className="settings-button gear-button"
          onClick={toggleSettings}
          aria-label="Settings"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
        </button>
      </div>
    </header>
  );
}

export default Header;
